(function($, window){

    $('.gi-term-button.accept').on('click', e => {
        Cookies.set('gi-reg-terms-accept', 1);
    });

    $('.gi-term-button.decline').on('click', e => {
        Cookies.remove('gi-reg-terms-accept');
    });

    if ($('body').hasClass('page-template-announcements')) {
        console.log(Cookies.get('gi-reg-terms-accept'));
        if (Cookies.get('gi-reg-terms-accept') != 1) {
            $('.grid').remove();
            location.href = "/regulatory-announcement/";
        }
    }
})(jQuery, window);
